import { Moment } from "moment";
import { JobStatus } from "./jobStatus";
import { jobStatusDuration } from "./jobStatusDuration";
import { JobType } from "./jobType";

/**
 * Known information about a job.
 */
interface Job {
  jobId: number;
  userId: number;
  clientId: number;
  jobType: JobType;
  projectId?: number;
  payload?: string;
  dateCreated: Moment;
  dateQueued?: Moment;
  dateStarted?: Moment;
  dateCancelled?: Moment;
  dateFinished?: Moment;
  success?: boolean;
  errorMessage?: boolean;
  jobStatus: JobStatus;
  lastHeartbeatDate: Date;
  jobStatusDuration: jobStatusDuration;
  jobLogUrl: string;
}

export {
  Job as default,
  JobStatus,
  JobType,
};
